languageSwitcher.$inject = [];

export function languageSwitcher() {
    return {
        bindToController: true,
        controller: LanguageSwitcherController,
        controllerAs: 'vm',
        restrict: 'E',
        scope: {},
        templateUrl: 'app/components/language-switcher.directive.html'
    };
}

class LanguageSwitcherController {
    constructor($translate, $cookies) {
        this.$translate = $translate;
        let worker = $cookies.get('x-egto-worker-name');
        if ('richmond' === worker) {
            this.currentLanguage = 'en';
        }
        else {
            this.currentLanguage = $translate.use();
        }
        $translate.onReady().then(() => { this._languageChanged(this.currentLanguage); });
    }

    _languageChanged(language) {
        this.currentLanguage = language;

        switch (this.currentLanguage) {
            case 'en':
                this.country = 'gb';
                break;
            case 'da':
                this.country = 'dk';
                break;
        }
    }

    changeLanguage() {
        let newLanguage;

        if (this.currentLanguage === 'en') {
            newLanguage = 'da';
        } else {
            newLanguage = 'en';
        }

        this.$translate.use(newLanguage)
            .then(language => { this._languageChanged(language); });
    }
}

LanguageSwitcherController.$inject = ['$translate', '$cookies'];